import { Grid, IconButton, InputAdornment, MenuItem, TextField, Tooltip } from "@material-ui/core";

import CloseIcon from "@material-ui/icons/Close";
import FindInPageIcon from "@material-ui/icons/FindInPage";
import MedicoInfo from "./MedicoInfo";
import MeditocModal from "../../../utils/MeditocModal";
import Pagination from "@material-ui/lab/Pagination";
import SearchIcon from "@material-ui/icons/Search";
import { useCallCenter } from "../../../../context/CallCenterContext";
import { useStyle } from "../../../../context/StyleContext";

export default function DirectorioMedico() {
    const { classes } = useStyle();
    const {
        listaColaboradores,
        listaEspecialidades,
        paginasTotalesColaboradores,
        modalOpenDirectorio,
        txtBuscador,
        txtUltimaBusqueda,
        txtEspecilidadFilter,
        paginaActual,
        handleOpenDirectorio,
        handleChangeEspecialidadFilter,
        handleChangePaginaActual,
        handleChangeBuscadorDirectorio,
        handleClickBuscarDirectorio,
        handleClickLimpiarDirectorio,
    } = useCallCenter();

    return (
        <MeditocModal
            open={modalOpenDirectorio}
            setopen={handleOpenDirectorio}
            title="Directorio médico de especialistas"
            okmessage="Cerrar directorio"
            size="large"
            hidecancel
        >
            <Grid container spacing={3}>
                <Grid item sm={6} xs={12}>
                    <TextField
                        variant="outlined"
                        fullWidth
                        label="Buscar..."
                        InputProps={{
                            endAdornment: (
                                <InputAdornment edge="start">
                                    {txtUltimaBusqueda !== "" ? (
                                        <Tooltip title="Limpiar búsqueda" arrow placement="top">
                                            <IconButton onClick={handleClickLimpiarDirectorio}>
                                                <CloseIcon />
                                            </IconButton>
                                        </Tooltip>
                                    ) : null}
                                    <Tooltip title="Iniciar búsqueda" arrow placement="top">
                                        <IconButton onClick={handleClickBuscarDirectorio}>
                                            <SearchIcon />
                                        </IconButton>
                                    </Tooltip>
                                </InputAdornment>
                            ),
                        }}
                        value={txtBuscador}
                        onChange={handleChangeBuscadorDirectorio}
                    />
                </Grid>
                <Grid item sm={6} xs={12}>
                    <TextField
                        fullWidth
                        variant="outlined"
                        label="Especialidad:"
                        select
                        value={txtEspecilidadFilter}
                        onChange={handleChangeEspecialidadFilter}
                        SelectProps={{ MenuProps: { PaperProps: { style: { maxHeight: 300 } } } }}
                    >
                        <MenuItem value="">
                            <em>Todas las especialidades</em>
                        </MenuItem>
                        {listaEspecialidades
                            .sort((a, b) => (a.sNombre > b.sNombre ? 1 : -1))
                            .map((especialidad) =>
                                especialidad.bInterno === true ? null : (
                                    <MenuItem
                                        key={especialidad.iIdEspecialidad}
                                        value={especialidad.iIdEspecialidad.toString()}
                                    >
                                        {especialidad.sNombre}
                                    </MenuItem>
                                )
                            )}
                    </TextField>
                </Grid>
                <Grid item xs={12}>
                    {listaColaboradores.map((medico) => (
                        <MedicoInfo key={medico.iIdColaborador} medico={medico} />
                    ))}
                    {paginasTotalesColaboradores > 0 ? (
                        <div className="directory-pagination-container">
                            <Pagination
                                classes={{ ul: classes.ul }}
                                count={paginasTotalesColaboradores}
                                size="large"
                                showFirstButton
                                showLastButton
                                color="primary"
                                page={paginaActual}
                                onChange={handleChangePaginaActual}
                            />
                        </div>
                    ) : (
                        <div className="center">
                            <FindInPageIcon style={{ fontSize: 150, color: "#ccc" }} />
                            <br />
                            <span className="price-content-description-normal">No se encontraron registros</span>
                        </div>
                    )}
                </Grid>
            </Grid>
        </MeditocModal>
    );
}
